var Model = require("../types/Model.js");
var xtend = require("xtend");

/**
 * This model is used for tracking a person's reminder history(irrespective of the status of the reminder).
 * A notification contains all of the messages, calls and banners that a person has received
 * @type {Model}
 */

module.exports = Model({
	name: "ownreminderhistory",
	init: init,
	uninit: uninit,

	listeners: listeners,
	triggers: triggers,
	_page: null,
	_history: null,
	_reminders: null,

	refresh: refresh,
	recalculate: recalculate
});

function listeners() {
	return {
		"ownreminders:updated": handle_reminders_updated,
		"connectivity:online": refresh,
		"ownreminders:view": recalculate,
		"ownpendingreminders:updated": refresh,
		"mqtt:$/reminders/removed": refresh
	};
}

function triggers() {
	return {
		more: more,
		view: view
	};
}

function init() {
	this._page = 0;
	this._history = [];
	this._reminders = [];
	this.push([]);
	this.refresh();
}

function uninit() {
	this._history = null;
	this._reminders = null;
	this._page = null;
}

function view() {
	this.refresh();
}

function refresh() {
	this._page = 0;
	this.emit("save:trigger:start");
	return this.api.reminders.history.listOwn("", this._page)
		.then(handle_load.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));
}

function handle_load(list) {
	this._history = list;
	this.recalculate();
}

function finishLoad() {
	this.emit("save:trigger:finish");
}

function more() {
	this.emit("usermetrics:trigger:track", "load more of own reminder history", {
		page: this._page
	});
	this.emit("save:trigger:start");
	this._page++;
	return this.api.reminders.history.listOwn("", this._page)
		.then(handle_more.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));
}

function handle_more(list) {
	this._history = this._history.concat(list);
	this.recalculate();
}

function handle_reminders_updated(data) {
	this._reminders = data.list;
	this.recalculate();
}

function recalculate() {
	var reminders = this._reminders;
	var history = this._history;

	this.push(history.map(function (item) {
		var reminder = findReminder(reminders, item) || {
			content: "N/A"
		};

		var reminderContent = reminder.content;
		var response = item.response || item.response === 0 ? item.response : "N/A";

		if (item.history.accepted) response = "Accepted";

		if (item.history.denied) response = "Denied";

		if (item.history.cleared) response = "Cleared";

		return xtend(item, {
			content: reminderContent,
			response: response
		});
	})
	);
}

function findReminder(reminders, item) {
	return reminders.reduce(function (result, rem) {
		if (result) return result;
		if (rem._id === item.reminder) return rem;
		return null;
	}, null);
}
